(function ($) {
	var quickView = document.getElementById("quick-view-content");
	var quickViewBody = quickView.querySelector(".quick-view-content__body");
	var close = quickView.querySelector(".quick-view-content__close");
	close.addEventListener("click", function () {
		quickView.classList.remove("active");
	});

	// refresh cart count
	function refreshCartCount(onSuccess) {
		jQuery.ajax({
			type: "GET",
			url: "/cart.js",
			dataType: "json",
			success: function (cart) {
				if (onSuccess) {
					onSuccess(cart);
				}
				var itemCount = cart.item_count;
				var cartCountElement = jQuery(
					".footer-cart__count .count-number",
				);
				cartCountElement.text(itemCount);

				// update cart price
				var cartPriceElement = jQuery(".footer-cart__price-subtotal");
				if (cartPriceElement.length) {
					var totalPrice = theme.Currency.formatMoney(
						cart.total_price,
						theme.moneyFormat,
					);
					cartPriceElement.html(totalPrice);
				}

				// update cart weight
				var cartWeightElement = jQuery(".footer-cart__weight-total");
				if (cartWeightElement.length) {
					var totalWeight = cart.total_weight / 1000; // Convert grams to kg
					cartWeightElement.text(totalWeight + " kg");
				}

				if (itemCount > 0) {
					jQuery(".header-cart").addClass("active");
				} else {
					jQuery(".header-cart").removeClass("active");
				}
			},
			error: function () {
				console.error("Failed to fetch cart data.");
			},
		});
	}

	window.refreshCartCount = refreshCartCount;

	function isExist(variantId, cartItems = []) {
		return cartItems.some((item) => item.variant_id === variantId);
	}

	function addToCart(variantId, quantity, onSuccess, onError) {
		refreshCartCount((cart) => {
			if (!isExist(variantId, cart.items)) {
				var items = [
					{
						id: variantId,
						quantity: quantity,
					},
				];
				jQuery.ajax({
					type: "POST",
					url: "/cart/add.js",
					data: JSON.stringify({ items: items }),
					dataType: "json",
					contentType: "application/json",
					success: function (res) {
						if (onSuccess) {
							onSuccess();
						}
						refreshCartCount();
					},
					error: function (res) {
						if (onError) {
							onError(res.responseJSON);
						}
						refreshCartCount();
						updateCartToProduct();
					},
				});
				return;
			}

			const form = new FormData();
			form.append("quantity", quantity);
			form.append("id", variantId);
			jQuery.ajax({
				type: "POST",
				url: "/cart/change.js",
				data: form,
				dataType: "json",
				contentType: false,
				processData: false,
				success: function () {
					if (onSuccess) {
						onSuccess();
					}
					refreshCartCount();
				},
				error: function (res) {
					if (onError) {
						onError(res.responseJSON);
					}
					refreshCartCount();
					updateCartToProduct();
				},
			});
		});
	}

	function updateCartToProduct() {
		jQuery.ajax({
			type: "GET",
			url: "/cart.js",
			dataType: "json",
			success: function (cart) {
				var cartItems = cart.items || [];
				cartItems.forEach(function (item) {
					const el = jQuery.find(
						`.qty-input[data-variant-id="${item.variant_id}"]`,
					);

					if (el.length) {
						jQuery(el).val(item.quantity);
					}
				});
				if (cartItems.length > 0) {
					jQuery(".header-cart").addClass("active");
				} else {
					jQuery(".header-cart").removeClass("active");
				}
			},
			error: function () {
				console.error("Failed to fetch cart data.");
			},
		});
	}

	document.addEventListener('loadDataFromAlgoliaFinish', (e) => {
    	updateCartToProduct();
		console.log('loadDataFromAlgoliaFinish')
	});


	jQuery(document).on(
		"submit",
		"#quick-view-content form[id^='product-form-']",
		function (e) {
			e.preventDefault();
			var form = jQuery(this);
			var variantId = form.find('input[name="id"]').val();
			if (!variantId) return;

			var submitBtn = form.find('button[type="submit"]');
			var originalText = submitBtn.text();

			submitBtn.text("Adding...");
			submitBtn.prop("disabled", true);

			var items = [
				{
					id: parseInt(variantId),
					quantity: 1,
				},
			];

			jQuery.ajax({
				type: "POST",
				url: "/cart/add.js",
				data: JSON.stringify({ items: items }),
				dataType: "json",
				contentType: "application/json",
				success: function () {
					submitBtn.text("Added!");
					setTimeout(function () {
						submitBtn.text(originalText);
						submitBtn.prop("disabled", false);
					}, 1500);
					refreshCartCount();
				},
				error: function () {
					submitBtn.text("Error");
					setTimeout(function () {
						submitBtn.text(originalText);
						submitBtn.prop("disabled", false);
					}, 1500);
				},
			});
		},
	);

	jQuery(document).on("change", ".trigger-add-to-cart", async function (e) {
		e.preventDefault();
		var input = jQuery(this);
		var maxQuantity = input.attr('max');
		var variantId = input.data("variant-id");
		
		if (!variantId) return;

		input.prop("disabled", true);
		input.addClass("loading");

		var step = await B2BUtils.getProductBunk(variantId);
		var quantity = B2BUtils.caculateQuantity(parseInt(input.val()), step);

		if(maxQuantity < step){
			quantity = 0;
			alert("Product is already sold out");
		}

		if(quantity > maxQuantity){
			quantity = maxQuantity;
			alert(`Only ${maxQuantity} items were added to your cart due to availability.`)
		}

		input.val(quantity);

		addToCart(
			variantId,
			quantity,
			() => {
				input.prop("disabled", false);
				input.removeClass("loading");
			},
			(res) => {
				var status = res.status;
				input.prop("disabled", false);
				input.removeClass("loading");
				alert(res.message);
			},
		);
	});

	function getSlider(product) {
		var images = product.images
			.map(
				(image) =>
					`<img class="item-slick" src="${image}" alt="${product.title}">`,
			)
			.join("");
		var nav = product.images
			.map(
				(image) =>
					`<img class="item-slick" src="${image}" alt="${product.title}">`,
			)
			.join("");

		return `<div class="quick-view-content__slick-slider">
        <div class="slider-for">
            ${images}
        </div>
        <div class="slider-nav">
            ${nav}
        </div>
    </div>`;
	}

	function getTitle(product) {
		return `<div class="quick-view-content__title">
        <h1>${product.title}</h1>
    </div>`;
	}

	function getPrice(product) {
		return `<div class="quick-view-content__price">
        <div class="quick-view-content__price-label">Retail price:</div>
        <div class="quick-view-content__price--regular" data-money-convertible>
        ${theme.Currency.formatMoney(product.price, theme.moneyFormat).replace(
			" kr",
			"<span> kr </span>",
		)}
        </div>
    </div>`;
	}

	function getDescription(product) {
		let desc = product.description || "";
		// let isTruncated = desc.length > 700;
		// if (isTruncated) {
		// 	desc = desc.slice(0, 700) + "...";
		// }
		return `<div class="quick-view-content__description">
		${desc}
	</div>`;
	}

	function getAddToCartButton(product) {
		var variant = product.variants && product.variants[0];
		var isAvailable = variant && variant.available;

		return `<form method="post" action="/cart/add" id="product-form-${product.id}">
			<input type="hidden" name="id" value="${variant.id}">
		</form>`;
	}

	jQuery(document).on("click", ".algolia-quick-view", function () {
		var handle = $(this).attr("data-handle");
		fetch(`/products/${handle}.js`)
			.then((res) => res.json())
			.then((product) => {
				console.log(product);
				var selected_or_first_available_variant_id = "";
				var variants = product.variants.map((variant) => {
					if (
						variant.available &&
						!selected_or_first_available_variant_id
					) {
						selected_or_first_available_variant_id = variant.id;
					}
					return {
						id: variant.id,
						title: variant.title,
						available: variant.available,
						featured_image: variant.featured_image,
						name: variant.name,
						price: variant.price,
						compare_at_price: variant.compare_at_price,
						inventory_management: variant.inventory_management,
						sku: variant.sku,
						quantity: variant.inventory_quantity,
					};
				});

				window._ReStockConfig.product = {
					selected_or_first_available_variant_id:
						selected_or_first_available_variant_id,
					id: product.id,
					title: product.title,
					handle: product.handle,
					available: product.available,
					featured_image: product.featured_image,
					images: product.images,
					price: product.price,
					compare_at_price: product.compare_at_price,
					vendor: product.vendor,
					selling_plan_groups: product.selling_plan_groups,
					variants: variants,
				};

				var anchor = `<a href="/products/${product.handle}" class="nm-product-link" data-product-handle="${product.handle}"></a>`;
				var content = `
                <div class="quick-view-content__left">
                    ${getSlider(product)}
                   
					
                </div>
                <div class="quick-view-content__right">
                    ${getTitle(product)}
                    ${getPrice(product)}
                    ${getDescription(product)}
                </div>
            `;

				jQuery("#quick-view-content .quick-view-content__body").html(
					content,
				);

				jQuery("#quick-view-content").addClass("active");

				// Initialize slick slider after content is added to DOM
				initQuickViewSliders();
				let attempts = 0;
				// const interval = setInterval(() => {
				// 	const buttons = document.querySelectorAll(
				// 		".restock-alerts-notify-button",
				// 	);

				// 	if (buttons.length > 1) {
				// 		buttons.forEach((btn, i) => {
				// 			if (i > 0) btn.remove();
				// 		});
				// 	}

				// 	attempts++;
				// 	if (attempts >= 5) {
				// 		clearInterval(interval);
				// 	}
				// }, 500);
			});
	});

	// Function to initialize slick sliders for quick view
	function initQuickViewSliders() {
		// window.jQuery may be overwritten by an app-injected jQuery without slick,
		// so pick the instance that actually has slick attached
		var $slick = [window.jQuerySlick, $, window.jQuery].find(function (jq) {
			return jq && jq.fn && jq.fn.slick;
		});
		if (!$slick) {
			// slick got attached to another jQuery (or never ran): load it onto the current one
			if (window.slickScriptUrl && !initQuickViewSliders.loading) {
				initQuickViewSliders.loading = true;
				jQuery.ajax({ url: window.slickScriptUrl, dataType: "script", cache: true })
					.done(function () {
						window.jQuerySlick = window.jQuery;
						initQuickViewSliders();
					})
					.always(function () {
						initQuickViewSliders.loading = false;
					});
				return;
			}
			console.error("jQuery or slick is not loaded");
			return;
		}

		// Initialize main slider
		$slick(".quick-view-content__slick-slider .slider-for").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			adaptiveHeight: true,
			asNavFor: ".slider-nav",
		});

		// Initialize navigation slider
		$slick(".quick-view-content__slick-slider .slider-nav").slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: ".slider-for",
			dots: false,
			centerMode: false,
			focusOnSelect: true,
			variableWidth: true,
			margin: 20,
			cssEase: "linear",
		});
	}

	jQuery(".toggle").on("click", function (e) {
		e.preventDefault();
		console.log("toggle");
		const target = jQuery(this).attr("href");
		jQuery(target).toggleClass("active");
	});

	document.addEventListener("algolia:rendered", function () {
		document
			.querySelectorAll(".restock-alerts-notify-button")
			.forEach((btn, index) => {
				if (index > 0) btn.remove();
			});
		if (
			typeof window.hengam !== "undefined" &&
			typeof hengam.init === "function"
		) {
			hengam.init();
		}
	});

	$(document).on("product:added", function (e, detail) {
		console.log("product added", detail);
		refreshCartCount();
	});
})(jQuery);
